import { createSelector } from 'reselect';
import { getFileInfoState } from './getFileInfoState';
const getErrorMessagesMap = (state, map) => map;
const getUploadErrors = createSelector([getFileInfoState], (fileInfoState) => {
    const uploadErrors = new Set();
    for (let i = 0; i < fileInfoState.allIds.length; i++) {
        const uploadError = fileInfoState.byId[fileInfoState.allIds[i]].uploadError;
        if (uploadError) {
            uploadErrors.add(uploadError);
        }
    }
    return Array.from(uploadErrors);
});
export const getFileUploadErrorSummaryMessages = createSelector([getUploadErrors, getErrorMessagesMap], (uploadErrors, errorMessageMap) => {
    const errorMessages = [];
    for (let i = 0; i < uploadErrors.length; i++) {
        if (errorMessageMap.has(uploadErrors[i])) {
            const errorMessage = errorMessageMap.get(uploadErrors[i]);
            errorMessages.push(errorMessage);
        }
    }
    return errorMessages;
});
//# sourceMappingURL=getFileUploadErrorSummaryMessages.js.map